// ======================================================================
// File Name       : GroupUserNotAdminContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, FormControl, Row, Col, Table, Button } from 'react-bootstrap';
import ModalWrapper from '../../components/modal/ModalWrapper';
import SelectBox from '../../components/SelectBox';
import Pagination from '../../components/Pagination';
import * as groupActions from '../../actions/GroupAction';
import * as modalActions from '../../actions/ModalAction';
import * as commonUtils from '../../utils';
import { USER_ATTRIBUTE_KEY_NUM_LIST } from '../../constants/UserAttributeConstants';
import { REDIRECT_MODAL } from '../../constants/GroupConstants';
import { RETURN_MAX_NUM, RETURN_MAX_NUM_1000 } from '../../constants';
import { USER_TYPE_LIST } from '../../constants/UserConstants';
import MessageSearch from '../../components/MessageSearch';
import GroupUserNotAdminList from '../../components/group/GroupUserNotAdminList';
import GroupUserNotAdminEditList from '../../components/group/GroupUserNotAdminEditList';
import * as MessageTemplate from '../../constants/MessageTemplate';
import CustomButton from '../../components/button/CustomButton';

class GroupUserNotAdminContainer extends Component {
  constructor() {
    super();
    this.state = {
      checkedUser: [],
      checkedUserOnPage: [],
      isAllowShowSearchMessage: false,
      isInit: true,
    };
    this.handleNextBtn = this.handleNextBtn.bind(this);
    this.handleBackBtn = this.handleBackBtn.bind(this);
    this.handleSearchConditionChange = this.handleSearchConditionChange.bind(this);
    this.handleSearchBtn = this.handleSearchBtn.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleUserCheck = this.handleUserCheck.bind(this);
    this.handleCheckAll = this.handleCheckAll.bind(this);
    this.handleAddBtn = this.handleAddBtn.bind(this);
    this.handleRemoveUser = this.handleRemoveUser.bind(this);
    this.handleRemoveAll = this.handleRemoveAll.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
  }

  componentDidMount() {
    const { group } = this.props;
    !group.searchResultNotAdmin.searched && this.handleSearchBtn();
  }

  handleNextBtn() {
    const { dispatch, modalId } = this.props;
    dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].OK));
  }

  handleBackBtn() {
    const { dispatch, modalId } = this.props;
    dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].CANCEL));
  }

  handleSearchConditionChange({ target }) {
    const { dispatch } = this.props;
    const { name, value } = target;
    dispatch(
      groupActions.editingNotAdminSearchCondition({
        [name]: name !== 'userType' ? value : parseInt(value, 10),
      }),
    );
  }

  handleSearchBtn() {
    const { dispatch, group } = this.props;
    this.setState({ checkedUserOnPage: [], isAllowShowSearchMessage: false, isInit: false },
      () => {
        dispatch(
          groupActions.searchUserNotAdmin({
            ...group.searchConditionNotAdmin,
            startPosition: 0,
            returnMaxNum: RETURN_MAX_NUM,
          }),
        ).then(() => {
          if (!this.state.isInit) {
            this.setState({ isAllowShowSearchMessage: true });
          }
        });
      },
    );
  }

  handlePageChange(start) {
    this.setState({ checkedUserOnPage: [] });
    const { dispatch, group } = this.props;
    dispatch(
      groupActions.searchUserNotAdmin({
        ...group.searchConditionNotAdmin,
        startPosition: start,
        returnMaxNum: RETURN_MAX_NUM,
      }),
    );
  }

  handleUserCheck(event) {
    const { value } = event.target;
    const checkedUser = [...this.state.checkedUser];
    const checkedUserOnPage = [...this.state.checkedUserOnPage];
    const pos = checkedUser.indexOf(value);
    pos < 0 ? checkedUser.unshift(value) : checkedUser.splice(pos, 1);
    const pos2 = checkedUserOnPage.indexOf(value);
    pos2 < 0 ? checkedUserOnPage.unshift(value) : checkedUserOnPage.splice(pos2, 1);
    this.setState({ checkedUser, checkedUserOnPage });
  }

  handleCheckAll() {
    const { group } = this.props;
    const searchResultNotAdmin = group.searchResultNotAdmin.allSecernIds.reduce((acc, cur) => {
      if (!group.editingUserGroupNotAdmin[cur]) {
        acc.push(cur);
      }
      return acc;
    }, []);
    const { checkedUserOnPage, checkedUser } = this.state;
    if (this.state.checkedUserOnPage.length === searchResultNotAdmin.length) {
      // uncheckAll
      checkedUserOnPage.map((userSecernId) => {
        const pos = checkedUserOnPage.indexOf(userSecernId);
        if (checkedUser.indexOf(userSecernId) > -1) {
          checkedUser.splice(pos, 1);
        }
        return null;
      });
      this.setState({ checkedUserOnPage: [], checkedUser });
      return;
    }
    // checkAll
    searchResultNotAdmin.map((userSecernId) => {
      if (checkedUser.indexOf(userSecernId) < 0) {
        checkedUser.unshift(userSecernId);
      }
      return null;
    });
    this.setState({ checkedUserOnPage: [...searchResultNotAdmin], checkedUser });
  }

  handleAddBtn() {
    const { dispatch } = this.props;
    this.scrollToBottom();
    dispatch(groupActions.editingUserNotAdmin({ addedList: this.state.checkedUser }));
  }

  handleRemoveUser(userSecernId) {
    const { dispatch } = this.props;
    const { checkedUser, checkedUserOnPage } = this.state;
    const pos = checkedUser.indexOf(userSecernId);
    if (pos >= 0) {
      checkedUser.splice(pos, 1);
    }
    const pos2 = checkedUserOnPage.indexOf(userSecernId);
    if (pos2 >= 0) {
      checkedUserOnPage.splice(pos2, 1);
    }
    this.setState({
      checkedUser,
      checkedUserOnPage,
    }, () => {
      dispatch(groupActions.editingUserNotAdmin({ removedSecern: userSecernId }));
    });
  }

  handleRemoveAll() {
    const { dispatch } = this.props;
    this.setState({
      checkedUser: [],
      checkedUserOnPage: [],
    }, () => {
      dispatch(groupActions.editingUserNotAdmin({ removedAll: true }));
    });
  }

  getModalOptions() {
    return {
      title: 'ユーザーグループに所属する受講ユーザーを選択してください',
      footerBtns: null,
    };
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  scrollToBottom() {
    const node = document.getElementById('scroll-table-not-admin'); // ReactDOM.findDOMNode(this.el);
    node.scrollIntoView({ behavior: 'smooth' });
  }
  render() {
    const { group, authority } = this.props;
    const { editingUserGroupNotAdmin, searchConditionNotAdmin, searchResultNotAdmin, recordNumUserInGroup } = group;
    const editingNotAdminGroup = Object.keys(editingUserGroupNotAdmin).sort((a, b) => {
      if (editingUserGroupNotAdmin[a].addNew && !editingUserGroupNotAdmin[b].addNew) {
        return -1;
      } else if (!editingUserGroupNotAdmin[a].addNew && editingUserGroupNotAdmin[b].addNew) {
        return 1;
      }
      if (editingUserGroupNotAdmin[a].index < editingUserGroupNotAdmin[b].index) {
        return -1;
      } else if (editingUserGroupNotAdmin[a].index > editingUserGroupNotAdmin[b].index) {
        return 1;
      }
      return 0;
    });
    return (
      <ModalWrapper {...this.getModalOptions()} hideModal={this.props.hideModal} dialogClassName="group-dialog">
        <div>
          <div className="max-width-950">
            <MessageSearch
              recordNum={searchResultNotAdmin ? searchResultNotAdmin.recordNum : 0}
              resultList={searchResultNotAdmin ? searchResultNotAdmin.allSecernIds : []}
              isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
              dismissMessage={this.dismissMessage}
            />
            <Form className='form-horizontal' onSubmit={(e) => { e.preventDefault();}}>
              <Form.Group className="row form-info">
                <Col as={Form.Label} sm={3}>ユーザー名</Col>
                <Col sm={9}>
                  <FormControl
                    name="userName"
                    value={searchConditionNotAdmin.userName || ''}
                    onChange={this.handleSearchConditionChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group className="row form-info">
                <Col as={Form.Label} sm={3}>ログインID</Col>
                <Col sm={9}>
                  <FormControl
                    name="loginId"
                    value={searchConditionNotAdmin.loginId || ''}
                    onChange={this.handleSearchConditionChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group className="row form-info">
                <Col as={Form.Label} sm={3}>自由記述領域</Col>
                <Col sm={2}>
                  <SelectBox
                    name="userAttributeKeyNum"
                    data={USER_ATTRIBUTE_KEY_NUM_LIST}
                    value={searchConditionNotAdmin.userAttributeKeyNum}
                    onChange={this.handleSearchConditionChange}
                  />
                </Col>
                <Col sm={7} className="padding-left-15">
                  <FormControl
                    name="userAttributeSearchText"
                    value={searchConditionNotAdmin.userAttributeSearchText || ''}
                    onChange={this.handleSearchConditionChange}
                  />
                </Col>
              </Form.Group>
              <Row>
                <Col sm={12} className="text-center padding-top-10">
                  {/* <Button bsStyle="primary" className="btn-96" onClick={this.handleSearchBtn}>
                    search
                  </Button> */}
                  <CustomButton
                    btnStyle="btn btn-primary btn-96"
                    handleClick={this.handleSearchBtn}
                    text="検索"
                    iconClass="bi bi-search"
                  />
                </Col>
              </Row>
            </Form>
            <GroupUserNotAdminList
              searchResultNotAdmin={searchResultNotAdmin}
              editingUserGroupNotAdmin={editingUserGroupNotAdmin}
              checkedUserOnPage={this.state.checkedUserOnPage}
              handlePageChange={this.handlePageChange}
              handleCheckAll={this.handleCheckAll}
              handleUserCheck={this.handleUserCheck.bind(this)}
              handleAddBtn={this.handleAddBtn}
            />
            <GroupUserNotAdminEditList
              editingUserGroupNotAdmin={editingUserGroupNotAdmin}
              handleRemoveAll={this.handleRemoveAll}
              handleRemoveUser={this.handleRemoveUser}
              handleBackBtn={this.handleBackBtn}
              handleNextBtn={this.handleNextBtn}
            />
          </div>
        </div>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { group, authority } = state;
  return { group, authority: authority.authorityInfo };
};
export default connect(mapStateToProps)(GroupUserNotAdminContainer);
